import moment from 'moment';
import {
  getDefaultValuesForIncome,
  getDisabledMembers,
} from 'pages/AffordaWagesAndIncome/utils';
import { FormattedMessage } from 'react-intl';
import { COMMON_PAY_FREQUENCY_OPTIONS } from './constants';
import {
  FIELD_AMOUNT,
  FIELD_DATE_FUTURE,
  FIELD_DATE_PAST,
  FIELD_GROUP_BUTTONS,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  FIELD_PAY_FREQUENCY,
  FIELD_PAY_FREQUENCY_ANNUALLY,
  FIELD_PAY_FREQUENCY_MONTHLY,
  FIELD_PAY_FREQUENCY_WEEKLY,
  FIELD_TEXT_REQUIRED,
  WAGES_AND_INCOME_COMMON_FIELD_NAMES,
} from './constants.fields';

export const MAX_RECORDS_BY_USER = 5;

export const GIFT_FIELD_NAMES = {
  annualAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
  endDate: WAGES_AND_INCOME_COMMON_FIELD_NAMES.endDate,
  memberId: WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
  monthlyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
  payFrequency: WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
  source: WAGES_AND_INCOME_COMMON_FIELD_NAMES.source,
  startDate: WAGES_AND_INCOME_COMMON_FIELD_NAMES.startDate,
  weeklyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
  whom: 'whom',
};

export const NEW_GIFT = {
  [GIFT_FIELD_NAMES.memberId]: '',
  [GIFT_FIELD_NAMES.source]: '',
  [GIFT_FIELD_NAMES.payFrequency]: '',
  [GIFT_FIELD_NAMES.weeklyAmount]: '',
  [GIFT_FIELD_NAMES.monthlyAmount]: '',
  [GIFT_FIELD_NAMES.annualAmount]: '',
  [GIFT_FIELD_NAMES.whom]: '',
  [GIFT_FIELD_NAMES.startDate]: '',
  [GIFT_FIELD_NAMES.endDate]: '',
};

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.gifts.title',
  description: 'afforda.wagesAndIncome.details.gifts.subtitle',
  addButton: 'afforda.wagesAndIncome.details.gifts.add',
  addCaption: 'afforda.wagesAndIncome.details.gifts.addDescription',
};

export const getDefaultValues = getDefaultValuesForIncome;

export const getFormProps = ({ items, memberId }) => {
  return {
    disabledMembers: getDisabledMembers(items, memberId, MAX_RECORDS_BY_USER),
  };
};

export const FIELD_SET_GIFT_PAY_FREQUENCY = [
  {
    ...FIELD_GROUP_BUTTONS,
    ...FIELD_MEMBER_SELECTED,
    label: (
      <FormattedMessage id="afforda.wagesAndIncome.details.gifts.payFrequency" />
    ),
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
    rules: {
      required: true,
    },
    options: Object.values(COMMON_PAY_FREQUENCY_OPTIONS)?.map((option) => ({
      value: option.value,
      label: <FormattedMessage id={option.text} />,
    })),
    GridProps: {
      xs: 12,
    },
    direction: 'row',
  },
  {
    ...FIELD_AMOUNT,
    ...FIELD_PAY_FREQUENCY_WEEKLY,
    label: (
      <FormattedMessage id="afforda.wagesAndIncome.details.weeklyAmount" />
    ),
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
    GridProps: {
      xs: 12,
    },
  },
  {
    ...FIELD_AMOUNT,
    ...FIELD_PAY_FREQUENCY_MONTHLY,
    label: (
      <FormattedMessage id="afforda.wagesAndIncome.details.gifts.montlyAmount" />
    ),
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
    GridProps: {
      xs: 12,
    },
  },
  {
    ...FIELD_AMOUNT,
    ...FIELD_PAY_FREQUENCY_ANNUALLY,
    label: (
      <FormattedMessage id="afforda.wagesAndIncome.details.annualAmount" />
    ),
    name: WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
    GridProps: {
      xs: 12,
    },
  },
];

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Whom
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_TEXT_REQUIRED,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.gifts.whom" />
      ),
      placeholder: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.payersFull',
      }),
      name: GIFT_FIELD_NAMES.whom,
    },

    // Pay Frequency
    ...FIELD_SET_GIFT_PAY_FREQUENCY,

    // begin
    {
      ...FIELD_PAY_FREQUENCY,
      ...FIELD_DATE_PAST,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.gifts.whenBegin" />
      ),
      name: GIFT_FIELD_NAMES.startDate,
      GridProps: {
        xs: 12,
      },
    },
    {
      ...FIELD_PAY_FREQUENCY,
      ...FIELD_DATE_FUTURE,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.gifts.whenEnd" />
      ),
      name: GIFT_FIELD_NAMES.endDate,
      GridProps: {
        xs: 12,
      },
      rules: {
        required: false,
        minDate: moment().startOf('day'),
      },
    },
  ];
};
